<div>
    <ul>
        <li *ngFor="let item of dataList" style="list-style: none;">
        
            <a [routerLink]="item[2]">
           
               <i class="fa {{item[0]}}"></i> {{item[1]}}
             </a>
        </li>  
    </ul>
</div>
